import { Rule } from "antd/lib/form";

export const legalEntityPattern: Rule = {
	pattern: /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/g,
	message: "Esse campo requer um CNPJ válido",
};
